<template>
  <div id="data--loader">
    <h1>Daten werden geladen</h1>
    sdfsdfdsf
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'DataLoader',
  data: function () {
    return {}
  },

  methods: {

    loadData: function () {
      console.log('LOAD DATA')
      const url = '../assets.json'
      console.log('LOAD DATA', url)
      axios.get(url)
        .then(response => {
          this.assetsData = response.data
          this.$router.push({ name: 'editor' })
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  created () {
    this.loadData()
  },
  computed: {
    assetsData: {
      get () {
        return this.$store.state.assetsData
      },
      set (value) {
        this.$store.dispatch('updateAssetsData', value)
      }
    }
  }
}
</script>

<style scoped>

</style>
